import config from '../config'
import CoreServices from './coreServices'
import { USERS } from '../constants/services'
import axios from 'axios'

class StatsService extends CoreServices {
  async getRates() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/stats/rates`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getStatistics(days) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/stats/statistics`, {
        params: days ? { days } : {},
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getCheckinList() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/stats/check-in`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async checkin() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/stats/check-in`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new StatsService(USERS.BASE)
